/**
 * Lightweight file exporting only the raw React context Provider and hook.
 *
 * Extracted from sync-context.tsx so that consumers who only need the
 * static SyncContextInternalProvider (e.g. the MFE's app-render-widget)
 * don't pull in heavy dependencies like @futrli/organisations, excel-modals,
 * or the full predict hooks tree.
 */
import { createContext } from '../context';
import { SyncContextType } from './types';

export const { Provider: SyncContextInternalProvider, useContext: useSyncContext } = createContext<SyncContextType>();
